import ReqCompraComponent from '@/components/compras/reqcompras/ReqCompraComponent'
import ReqCompraReporteComponent from '@/components/compras/reqcompras/ReqCompraReporteComponent'
import ReqCompraFormComponent from '@/components/compras/reqcompras/ReqCompraFormComponent'
import CotizacionesComponent from '@/components/compras/cotizaciones/CotizacionesComponent'
import CotizacionesFormComponent from '@/components/compras/cotizaciones/CotizacionesFormComponent'
import OrdenCompraComponent from '@/components/compras/ordencompra/OrdenCompraComponent'
import OrdenCompraFormComponent from '@/components/compras/ordencompra/OrdenCompraFormComponent'
import InvPorProveedor from '@/components/compras/reportes/InvPorProveedor'
import ListaPreciosComprasComponent from '@/components/compras/lista_precios_compras/ListaPreciosComprasComponent'
import PreciosProveedorComponent from '@/components/compras/reportes/PreciosProveedorComponent'
import CostoProveedorReportComponent from '@/components/compras/reportes/CostoProveedorReportComponent'
import FacturaComponent from "@/components/compras/facturas_proveedores/FacturaComponent";
import FacturaFormComponent from "@/components/compras/facturas_proveedores/FacturaFormComponent";
import orden_compra_pendiente from "@/components/compras/reportes/orden_compra_pendiente";
import oc_pendiente_x_subcategoria_proveedor from "@/components/compras/reportes/oc_pendiente_x_subcategoria_proveedor";




export default [{
        path: "/compras/factura/",
        name: "compras-factura",
        component: FacturaComponent,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/compras/factura/:id/",
        name: "compras-factura-editar",
        component: FacturaFormComponent,
        meta: {
          requiresAuth: true,
        },
      },{
        path: "/compras/oc-pendientes/",
        name: "compras-oc-pendientes",
        component: orden_compra_pendiente,
        meta: {
          requiresAuth: true,
        },
      },{
        path: '/compras/req-compra/nuevo',
        name: 'compras-reqcompra-nuevo',
        component: ReqCompraFormComponent,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/compras/req-compra/editar/:id/',
        name: 'compras-reqcompra-editar',
        component: ReqCompraFormComponent,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/compras/req-compra/',
        name: 'compras-reqcompra',
        component: ReqCompraComponent,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/compras/req-compra/reporte/:id/',
        name: 'compras-reqcompra-reporte',
        component: ReqCompraReporteComponent,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/compras/cotizaciones/editar/:id/',
        name: 'compras-cotizaciones-editar',
        component: CotizacionesFormComponent,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/compras/cotizaciones/nueva',
        name: 'compras-cotizaciones-nueva',
        component: CotizacionesFormComponent,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/compras/cotizaciones/',
        name: 'compras-cotizaciones',
        component: CotizacionesComponent,
        meta: {
            requiresAuth: true
        },
    }, {
        path: '/compras/ordencompra/editar/:id/',
        name: 'compras-ordencompra-editar',
        component: OrdenCompraFormComponent,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/compras/ordencompra/nueva',
        name: 'compras-ordencompra-nueva',
        component: OrdenCompraFormComponent,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/compras/ordencompra/',
        name: 'compras-ordencompra',
        component: OrdenCompraComponent,
        meta: {
            requiresAuth: true
        },
    }, {
        path: '/compras/reportes/inv-x-proveedor/',
        name: 'compras-inv-x-proveedor',
        component: InvPorProveedor,
        meta: {
            requiresAuth: true
        },
    }, {
        path: '/compras/lista-precios-compras/',
        name: 'compras-lista-precios-compras',
        component: ListaPreciosComprasComponent,
        meta: {
            requiresAuth: true
        },
    },
    {
        path: '/compras/precios_proveedor/',
        name: 'compras-precios_proveedor',
        component: PreciosProveedorComponent,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/reporte/proveedor_costo/',
        name: 'reporte-proveedor_costo',
        component: CostoProveedorReportComponent,
        meta: {
            requiresAuth: true,
        }
    },{
        path: "/compras/oc-pendientes-x-subcategoria/",
        name: "compras-oc-pendientes-x-subcategoria",
        component: oc_pendiente_x_subcategoria_proveedor,
        meta: {
          requiresAuth: true,
        },
      },
]